<template>
  <div class="investing-page-wrapper">
    <static-pages-header @mobileMenuToggle="mobileMenuToggle"/>

    <section class="heading-container" :class="{'heading-container-mobile-menu-open': isMobileMenuOpen}">
      <div class="heading-block">
        <h1 class="heading">
          {{ $t('message.investingPage.heading.title') }}
        </h1>
        <p class="heading-desc heading-desc--main">
          {{ $t('message.investingPage.heading.firstDesc') }}
        </p>
        <div class="heading-btn-block" v-if="!isAuthorized">
          <base-button
            :text="$t('message.mainPage.heading.btn')"
            @click="signUp()"
          />
        </div>
      </div>
      <img class="heading-img" src="../../../public/custom/images/main-page/phone-heading-img.png" alt="">
    </section>

    <section class="advantages-container">
      <h2 class="advantages-title">{{ $t('message.investingPage.advantages.title') }}</h2>
      <div class="advantages-block">
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/7.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.first') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/calendar.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.second') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/loan-percent.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.third') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/security.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.seventh') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/ssl.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.fourth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/rating.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.fifth') }}</div>
        </div>
        <div class="advantages-item">
          <div class="advantages-item-img-block">
            <img src="../../../public/custom/images/main-page/advantages/judge.svg" alt="">
          </div>
          <div class="advantages-item-desc">{{ $t('message.investingPage.advantages.items.sixth') }}</div>
        </div>
      </div>
    </section>

    <section class="hiw-container">
      <div class="hiw-block">
        <div class="hiw-data">
          <h2 class="hiw-data-title">{{ $t('message.investingPage.hiw.title') }}</h2>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">1</div>
              <span>{{ $t('message.investingPage.hiw.first.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.investingPage.hiw.first.desc') }}
            </div>
          </div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">2</div>
              <span>{{ $t('message.investingPage.hiw.second.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.investingPage.hiw.second.desc') }}
            </div>
          </div>
          <div class="hiw-item">
            <div class="hiw-item-title">
              <div class="hiw-item-number">3</div>
              <span>{{ $t('message.investingPage.hiw.third.title') }}</span>
            </div>
            <div class="hiw-desc">
              {{ $t('message.investingPage.hiw.third.desc') }}
            </div>
          </div>
        </div>
        <img class="hiw-image" src="../../../public/custom/images/main-page/investing-hiw-image.png" alt="">
      </div>
    </section>

    <section class="memo-container">
      <div class="memo-block">
        <div class="memo-title-block">
          <img class="memo-title-img" src="../../../public/custom/images/main-page/loan-memo-img.png" alt="">
          <h2 class="memo-title">{{ $t('message.investingPage.memo.title') }}</h2>
        </div>
        <div class="memo-data-block">
          <ul class="memo-data-item">
            <li>
              {{ $t('message.investingPage.memo.items.first.begin') }}
              <router-link class="memo-data-item-link" to="msi">{{ $t('message.investingPage.memo.items.first.link') }}</router-link>
              {{ $t('message.investingPage.memo.items.first.end') }}
            </li>
            <li>
              {{ $t('message.investingPage.memo.items.second') }}
            </li>
            <li>
              {{ $t('message.investingPage.memo.items.third.begin') }}
              <b>{{ $t('message.investingPage.memo.items.third.bold') }}</b>
              {{ $t('message.investingPage.memo.items.third.end') }}
            </li>
            <!-- <li>
              {{ $t('message.investingPage.memo.items.fourth') }}
            </li> -->
            <li>
              {{ $t('message.investingPage.memo.items.fifth.begin') }}
              <!-- <span class="memo-important">{{ $t('message.investingPage.memo.items.fifth.important') }}</span>
              {{ $t('message.investingPage.memo.items.fifth.end') }} -->
            </li>
            <li>
              {{ $t('message.investingPage.memo.items.sixth.begin') }}
              <!-- {{ $t('message.investingPage.memo.items.sixth.beginImportant') }}
              <router-link class="memo-data-item-link" to="/">{{ $t('message.investingPage.memo.items.sixth.link') }}</router-link>
              {{ $t('message.investingPage.memo.items.sixth.endImportant') }} -->
            </li>
          </ul>
          <ul class="memo-data-item">
            <li>
              {{ $t('message.investingPage.memo.items.seventh.begin') }}
              <!-- <router-link class="memo-data-item-link" to="documents">{{ $t('message.investingPage.memo.items.seventh.link') }}</router-link>
              {{ $t('message.investingPage.memo.items.seventh.end') }} -->
            </li>
            <li>
              {{ $t('message.investingPage.memo.items.eighth.begin') }}
              <router-link class="memo-data-item-link" to="documents">{{ $t('message.investingPage.memo.items.eighth.link') }}</router-link>
            </li>
            <li>
              {{ $t('message.investingPage.memo.items.tenth') }}
            </li>
            <li>
              {{ $t('message.investingPage.memo.items.ninth.begin') }}
              <router-link class="memo-data-item-link" to="arbitration">{{ $t('message.investingPage.memo.items.ninth.link') }}</router-link>
              {{ $t('message.investingPage.memo.items.ninth.end') }}
            </li>
          </ul>
        </div>
        <div class="memo-data-note">
          {{ $t('message.investingPage.memo.note.begin') }}
          <a class="memo-data-item-link" href="https://creditregister.by/" target="_blank" rel="noopener noreferrer">{{ $t('message.investingPage.memo.note.link') }}</a>
          {{ $t('message.investingPage.memo.note.end') }}
        </div>
      </div>
    </section>

    <section class="sign-up-block" v-if="!isAuthorized">
      <h2 class="sign-up-title">
        {{ $t('message.investingPage.signUp.title') }}
      </h2>
      <div class="sign-up-btn-block">
        <base-button
          :text="$t('message.investingPage.signUp.btn')"
          @click="signUp()"
        />
      </div>
    </section>
  </div>
</template>

<script>
import StaticPagesHeader from '../../components/common/StaticPagesHeader.vue';
import { mapGetters } from 'vuex';
import BaseButton from '../../components/base/BaseButton.vue';

export default {
  name: 'Investing',
  components: {
    StaticPagesHeader,
    BaseButton
  },
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    },
    signUp() {
      this.$router.push({ name: 'msi' });
    },
  },
  computed: {
    ...mapGetters(['profile']),
    isAuthorized() {
      return this.profile?.role;
    },
  }
}
</script>

<style lang="scss" scoped>
  .investing-page-wrapper {
    @include base-page-wrapper;
    @include static-heading-container;

    .heading-container {
      margin-bottom: 140px;
      padding-top: 50px;
      background-color: #ffffff;
    }

    .heading-desc {
      max-width: 664px;
      font-size: 18px;
      line-height: 24.3px;
      color: #3d3f42;
    }

    .heading-desc--main {
      margin-bottom: 60px;
    }

    .heading {
      font-size: 50px;
      line-height: 61px;
    }
  }

  .advantages-container {
    @include base-page-container;

    margin-bottom: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .advantages-title,
  .sign-up-title {
    font-weight: 700;
    font-size: 40px;
    line-height: 50px;
    color: #121212;
    text-align: center;
    margin: 0 0 50px;
  }

  .memo-title {
    font-weight: 700;
    font-size: 40px;
    line-height: 50px;
    color: #121212;
    text-align: left;
    margin: 0;
  }

  .advantages-block {
    width: 100%;
    max-width: 1730px;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 20px;
  }

  .advantages-item:nth-child(-n + 4) {
    grid-column: span 3;
  }

  .advantages-item:nth-child(n + 5) {
    grid-column: span 4;
  }

  .advantages-item {
    min-height: 240px;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow: 2px 2px 30px rgba(176, 178, 181, 0.2);
    border-radius: 20px;
    background: #ffffff;
  }

  .advantages-item-img-block {
    width: 84px;
    height: 84px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      max-width: 84px;
      max-height: 84px;
      height: auto;
    }
  }

  .advantages-item-desc {
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: #000000;
  }

  .hiw-container {
    width: 100%;
    max-width: 1730px;
    padding: 0 202px 140px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }

  .hiw-block {
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 100px;
  }

  .hiw-data {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0;
  }

  .hiw-item {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .hiw-image {
    flex-shrink: 0;
    width: 563px;
    max-width: 45%;
    height: 525px;
    object-fit: contain;
  }

  .hiw-item-number {
    flex-shrink: 0;
    height: 37px;
    width: 37px;
    margin-right: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 18.5px;
    background-color: #41bf7b;
    color: #ffffff;
    font-weight: 600;
    font-size: 26px;
    line-height: 35px;
  }

  .hiw-item-title {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 26px;
    line-height: 35px;
    color: #121212;
  }

  .hiw-desc {
    margin-left: 57px;
    font-weight: 400;
    font-size: 18px;
    line-height: 24.3px;
    color: #474747;
  }

  .hiw-data-title {
    font-weight: 700;
    font-size: 40px;
    line-height: 50px;
    color: #121212;
    text-align: left;
    margin-bottom: 0;
  }

  .sign-up-block {
    padding-bottom: 140px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .sign-up-btn-block {
    height: 65px;
    width: 300px;
    max-width: 90%;
  }

  .memo-container {
    @include base-page-container;

    margin-bottom: 140px;
    padding: 90px 200px 90px 150px;
    box-sizing: border-box;
    background: #f8f8f8;
    border-radius: 40px;
  }

  .memo-block {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .memo-title-block {
    margin-bottom: 50px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  .memo-title-img {
    width: 90px;
    height: 90px;
    margin-right: 30px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .memo-data-block {
    margin-bottom: 60px;
    display: flex;
    justify-content: space-between;
    gap: 94px;
  }

  .memo-data-item {
    flex: 1;
    min-width: 0;
    margin: 0;
    padding: 0;
    list-style-position: outside;
    font-weight: 400;
    font-size: 18px;
    line-height: 24.3px;
    color: #333333;

    li {
      margin-bottom: 10px;
      list-style-type: none;
    }
  }

  .memo-important {
    font-weight: 700;
  }

  .memo-data-note {
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    line-height: 24.3px;
    color: #333333;
  }

  .memo-data-item-link {
    color: #2f80ed;
    text-decoration: none;
  }

  @media screen and (max-width: 1770px) {
    .advantages-container {
      width: 1400px;
    }

    .advantages-item-img-block {
      width: 54px;
      height: 54px;

      img {
        max-width: 54px;
        max-height: 54px;
      }
    }
  }

  @media screen and (max-width: 1750px) {
    .advantages-container {
      margin-bottom: 110px;
    }

    .advantages-item {
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 1610px) {
    .memo-container {
      padding: 90px 100px 90px 90px;
    }

    .hiw-container {
      padding-left: 5%;
      padding-right: 5%;
    }
  }

  @media screen and (max-width: 1400px) {
    .investing-page-wrapper .heading {
      font-size: calc(28px + 22 * (100vw / 1920));
      line-height: 1.22;
    }

    .advantages-title,
    .sign-up-title,
    .memo-title {
      font-size: calc(28px + 12 * (100vw / 1920));
      line-height: 1.25;
    }

    .hiw-data-title {
      font-size: calc(28px + 12 * (100vw / 1920));
      line-height: 1.25;
    }

    .memo-data-item,
    .memo-data-note {
      font-size: calc(13px + 5 * (100vw / 1920));
    }
  }

  @media screen and (max-width: 1300px) {
    .hiw-container {
      padding-left: 2.5%;
      padding-right: 2.5%;
    }

    .hiw-block {
      gap: 60px;
    }

    .hiw-image {
      max-width: 42%;
      height: 480px;
    }

    .hiw-data-title {
      margin-bottom: 10px;
    }
  }

  @media screen and (max-width: 1150px) {
    .memo-container {
      padding: 4%;
    }

    .heading-block {
      width: 50%;
    }

    .investing-page-wrapper .heading-desc {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 1100px) {
    .advantages-block {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .advantages-item:nth-child(-n + 4),
    .advantages-item:nth-child(n + 5) {
      grid-column: auto;
    }
  }

  @media screen and (max-width: 1060px) {
    .hiw-image {
      height: 370px;
    }
  }

  @media screen and (max-width: 890px) {
    .heading-block {
      width: 90%;
    }

    .investing-page-wrapper .heading,
    .heading-desc {
      max-width: 100%;
      text-align: start;
    }
  }

  @media screen and (max-width: 750px) {
    .memo-data-block {
      flex-direction: column;
      gap: 0;
    }

    .memo-data-item {
      width: 100%;
    }
  }

  @media screen and (max-width: 550px) {
    .heading-img {
      display: none;
    }

    .investing-page-wrapper .heading-container {
      margin-bottom: 70px;
    }
  }

  @media screen and (max-width: 500px) {
    .heading-block {
      width: 95%;
    }

    .memo-data-item {
      padding-left: 5%;
    }
  }

  @media screen and (max-width: 890px) {
    .hiw-block {
      flex-direction: column;
      align-items: center;
    }

    .hiw-data {
      width: 100%;
      margin-bottom: 40px;
    }

    .hiw-image {
      max-width: 90%;
      width: 90%;
      height: auto;
    }

    .hiw-data-title {
      margin-bottom: 30px;
    }

    .hiw-item {
      margin-bottom: 25px;
    }

    .hiw-item-title {
      flex-direction: column;
      align-items: flex-start;

      span {
        margin-bottom: 8px;
      }
    }

    .hiw-item-number {
      margin-bottom: 10px;
    }

    .hiw-desc {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 670px) {
    .advantages-block {
      grid-template-columns: 1fr;
    }

    .advantages-item {
      min-height: 0;
    }

    .advantages-item-desc {
      font-size: 16px;
      line-height: 24px;
    }

    .advantages-title,
    .memo-title {
      text-align: start;
    }

    .memo-title {
      font-size: calc(22px + 8 * (100vw / 1920));
    }

    .memo-title-img {
      width: 70px;
      height: 70px;
    }
  }
</style>
